import { memo } from "react";
import { Button } from "@/components/ui/button";
import { MapPin, CheckCircle, ShieldCheck, Clock } from "lucide-react";
import { QuoteForm } from "@/components/QuoteForm";

const GOOGLE_MAPS_URL = "https://www.google.com/maps/place/104+Rue+de+la+Gare,+79000+Niort,+France";

const BENEFITS = [
  { Icon: CheckCircle, bg: "bg-red-100", color: "text-red-600", title: "Diagnostic gratuit", desc: "Nous analysons votre appareil sans frais" },
  { Icon: ShieldCheck, bg: "bg-emerald-100", color: "text-emerald-600", title: "Garantie 6 mois", desc: "Toutes nos réparations sont garanties" },
  { Icon: Clock, bg: "bg-purple-100", color: "text-purple-600", title: "Réponse rapide", desc: "Devis envoyé sous 24h maximum" },
];

export const QuoteSection = memo(() => (
  <section className="section-padding bg-slate-50">
    <div className="container-custom">
      <div className="grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Demandez votre devis gratuit</h2>
          <p className="text-lg text-slate-600 mb-8">
            Recevez une estimation précise sous 24h. Sans engagement.
          </p>

          <div className="space-y-6">
            {BENEFITS.map(({ Icon, bg, color, title, desc }) => (
              <div key={title} className="flex items-start gap-4 card-lift p-4 bg-white rounded-xl">
                <div className={`w-12 h-12 rounded-xl ${bg} flex items-center justify-center flex-shrink-0`}>
                  <Icon className={`h-6 w-6 ${color}`} />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-900 mb-1">{title}</h3>
                  <p className="text-slate-600">{desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Map Preview */}
          <div className="mt-8 rounded-xl overflow-hidden shadow-lg card-lift">
            <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer">
              <div className="relative h-48">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2775.5!2d-0.4640!3d46.3230!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4806476e21ecbfed%3A0x4a1fa3c7e8d0f8a!2s104%20Rue%20de%20la%20Gare%2C%2079000%20Niort%2C%20France!5e0!3m2!1sfr!2sfr!4v1"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  title="Localisation Mediastore"
                />
              </div>
            </a>
            <div className="bg-white p-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-red-600" />
                <span className="text-sm font-medium">104 Rue de la Gare, Niort</span>
              </div>
              <Button variant="link" className="text-red-600 p-0 h-auto" asChild>
                <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer">
                  Voir l&apos;itinéraire
                </a>
              </Button>
            </div>
          </div>
        </div>

        <div className="card-lift">
          <QuoteForm />
        </div>
      </div>
    </div>
  </section>
));

QuoteSection.displayName = "QuoteSection";
